import { render, staticRenderFns } from "./DivSelection.vue?vue&type=template&id=8ff7916c&scoped=true&"
import script from "./DivSelection.vue?vue&type=script&lang=js&"
export * from "./DivSelection.vue?vue&type=script&lang=js&"
import style0 from "./DivSelection.vue?vue&type=style&index=0&id=8ff7916c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff7916c",
  null
  
)

export default component.exports